import { Injectable, inject } from '@angular/core';
import {Router, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {PrestatieService} from '../prestatie/prestatie.service';

@Injectable({
  providedIn: 'root'
})
export class InactievePrestatieGuard {
  private prestatieService = inject(PrestatieService);
  private router = inject(Router);

  private canActivate(): Observable<boolean | UrlTree> {
    return this.prestatieService.getActievePrestatie$()
      .pipe(
        map(prestatie => !!prestatie ? this.router.parseUrl(`/prestatie/${prestatie.getId()}/diensten`) : true),
      );
  }
}
